export function getPasswordError(password: string) {
  if (password.length < 8) return "Пароль должен содержать не менее 8 символов";
  if (!/[0-9]/.test(password)) return "Пароль должен содержать хотя бы одну цифру";
  if (!/[A-ZА-ЯЁ]/.test(password)) return "Пароль должен содержать хотя бы одну заглавную букву";
  return "";
}

export function getPasswordConfirmationError(password: string, confirmation: string) {
  if (!confirmation) return "Подтвердите пароль";
  if (password !== confirmation) return "Пароли не совпадают";
  return "";
}

export function formatRuPhone(value: string) {
  const rawDigits = value.replace(/\D/g, "");
  if (!rawDigits) return "";
  const digits = rawDigits.replace(/^8/, "7").replace(/^7?/, "7").slice(0, 11);
  const withoutCountry = digits.slice(1);
  const parts = [
    withoutCountry.slice(0, 3),
    withoutCountry.slice(3, 6),
    withoutCountry.slice(6, 8),
    withoutCountry.slice(8, 10),
  ];

  let result = "+7";
  if (parts[0]) result += ` (${parts[0]}`;
  if (parts[0].length === 3) result += ")";
  if (parts[1]) result += ` ${parts[1]}`;
  if (parts[2]) result += `-${parts[2]}`;
  if (parts[3]) result += `-${parts[3]}`;
  return result;
}

export function normalizeApiError(error: unknown, fallback: string) {
  const data = (error as any)?.response?.data;
  const detail = data?.detail;
  if (typeof detail === "string") return detail;
  if (typeof data?.message === "string") return data.message;
  return fallback;
}
